<template lang="pug">
  .view-control-lessons.container
    ui-tabs(:items="tabs" v-model="activeTab")
      template(slot="actions")
        .button.is-primary(@click="createLesson")
          b-icon(icon="plus")
          span Создать материал

      b-table.is-clickable(:data="tabLessons" :loading="lessons.$state.loading" @click="onRowClick" hoverable)
        template(v-slot="{row}")
          b-table-column(field="id" label="ID" width="30" numeric sortable) {{ row.id }}
          b-table-column(field="name" label="Название" sortable)
            b-icon(icon="book-open-variant")
            span  {{ row.name }}
          b-table-column(field="category" label="Категория" sortable) {{ row.category ? row.category.name : '-' }}
          b-table-column(field="actions" label="Действия" width="30")
            router-link.button.is-small.is-rounded(tag="button" :to="{name:'control.lessons.edit', params:{id: row.id}}" exact)
              b-icon(icon="pencil-circle" type='is-info')
              span Редактировать

        //- Пусто
        template(v-slot:empty)
          section.section(v-if="lessons.$state.loaded")
            .content.has-text-grey.has-text-centered
              p: b-icon(icon="emoticon-sad" size="is-large")
              p Нет записей
</template>

<script>
import Lesson from '@/models/Lesson';

export default {
  name: 'view-control-lessons',

  data: () => ({
    lessons: Lesson.collection(),
    activeTab: 0,
    tabs: [
      { label: 'Активные материалы', filter: { available_now: true } },
      { label: 'Неактивные материалы', filter: { available_now: false } },
    ],
  }),

  computed: {
    currentTabFilter() {
      return this.tabs[this.activeTab].filter;
    },

    tabLessons() {
      return this.lessons.filter(this.currentTabFilter);
    },
  },

  methods: {
    onRowClick({ id }) {
      this.$router.push({ name: 'control.lessons.edit', params: { id } });
    },

    createLesson() {
      let lesson = new Lesson({ name: '-' });

      lesson.$save().then(({ data }) => {
        this.$router.push({
          name: 'control.lessons.edit',
          params: { id: data.id },
        });
      });
    },
  },

  created() {
    this.lessons.$fetch({ include: 'category' });
  },
};
</script>
